/* tslint:disable */
/* eslint-disable */
export enum WorkJournalEntryLineRoleEnum {
  Manual = 'manual',
  Tax = 'tax',
  Control = 'control'
}
